class ResponsiveCardsCarousel {
  constructor(sectionId) {
    this.section = document.getElementById(sectionId);
    if (!this.section) return;
    
    this.carouselContainer = this.section.querySelector('.cards-carousel-mobile');
    if (!this.carouselContainer) return;
    
    this.track = this.carouselContainer.querySelector('.carousel-track');
    this.slides = this.carouselContainer.querySelectorAll('.carousel-slide');
    this.dots = this.carouselContainer.querySelectorAll('.carousel-dot');
    this.prevBtn = this.carouselContainer.querySelector('.prev-btn');
    this.nextBtn = this.carouselContainer.querySelector('.next-btn');
    
    if (!this.track || this.slides.length === 0) return;
    
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.autoAdvanceInterval = null;
    
    this.init();
  }
  
  init() {
    this.updateCarousel();
    this.setupEventListeners();
    
    // Only auto-advance on mobile
    if (window.innerWidth <= 768 && this.totalSlides > 1) {
      this.startAutoAdvance();
    }
    
    // Handle window resize
    window.addEventListener('resize', this.handleResize.bind(this));
  }
  
  updateCarousel() {
    this.track.style.transform = `translateX(-${this.currentSlide * 100}%)`;
    
    this.dots.forEach((dot, index) => {
      dot.classList.toggle('active', index === this.currentSlide);
    });
    
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentSlide === 0;
    }
    
    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentSlide === this.totalSlides - 1;
    }
  }
  
  nextSlide() {
    if (this.currentSlide < this.totalSlides - 1) {
      this.currentSlide++;
      this.updateCarousel();
    }
  }
  
  prevSlide() {
    if (this.currentSlide > 0) {
      this.currentSlide--;
      this.updateCarousel();
    }
  }
  
  goToSlide(index) {
    if (index >= 0 && index < this.totalSlides) {
      this.currentSlide = index;
      this.updateCarousel();
    }
  }
  
  startAutoAdvance() {
    this.stopAutoAdvance();
    this.autoAdvanceInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  }
  
  stopAutoAdvance() {
    if (this.autoAdvanceInterval) {
      clearInterval(this.autoAdvanceInterval);
      this.autoAdvanceInterval = null;
    }
  }
  
  setupEventListeners() {
    // Button events
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => {
        this.prevSlide();
        this.stopAutoAdvance();
      });
    }
    
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => {
        this.nextSlide();
        this.stopAutoAdvance();
      });
    }
    
    // Dot events
    this.dots.forEach(dot => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.getAttribute('data-index'));
        this.goToSlide(index);
        this.stopAutoAdvance();
      });
    });
    
    // Touch/swipe events
    let startX = 0;
    let endX = 0;
    
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      this.stopAutoAdvance();
    });
    
    this.track.addEventListener('touchmove', (e) => {
      endX = e.touches[0].clientX;
    });
    
    this.track.addEventListener('touchend', () => {
      const threshold = 50;
      
      if (startX - endX > threshold) {
        this.nextSlide();
      } else if (endX - startX > threshold) {
        this.prevSlide();
      }
      
      setTimeout(() => {
        if (window.innerWidth <= 768 && this.totalSlides > 1) {
          this.startAutoAdvance();
        }
      }, 3000);
    });
    
    // Pause auto-advance on hover (for devices with mouse)
    this.track.addEventListener('mouseenter', () => {
      this.stopAutoAdvance();
    });
    
    this.track.addEventListener('mouseleave', () => {
      if (window.innerWidth <= 768 && this.totalSlides > 1) {
        this.startAutoAdvance();
      }
    });
    
    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.prevSlide();
        this.stopAutoAdvance();
      } else if (e.key === 'ArrowRight') {
        this.nextSlide();
        this.stopAutoAdvance();
      }
    });
  }
  
  handleResize() {
    this.stopAutoAdvance();
    
    if (window.innerWidth <= 768 && this.totalSlides > 1) {
      this.startAutoAdvance();
    }
  }
  
  destroy() {
    this.stopAutoAdvance();
    window.removeEventListener('resize', this.handleResize);
  }
}

// Initialize carousels on page load
document.addEventListener('DOMContentLoaded', () => {
  const carouselSections = document.querySelectorAll('.cards-carousel-mobile');
  
  carouselSections.forEach((carouselContainer) => {
    const sectionId = carouselContainer.getAttribute('data-section-id');
    if (sectionId) {
      new ResponsiveCardsCarousel(`responsive-cards-${sectionId}`);
    }
  });
});

// Handle Shopify theme editor
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.responsive-cards-section');
    if (section) {
      const carouselContainer = section.querySelector('.cards-carousel-mobile');
      if (carouselContainer) {
        const sectionId = carouselContainer.getAttribute('data-section-id');
        if (sectionId) {
          new ResponsiveCardsCarousel(`responsive-cards-${sectionId}`);
        }
      }
    }
  });
}